import * as React from 'react'
import {connect} from 'react-redux';
import {
    createBusinessObjectAttributeValue,
    deleteBusinessObjectAttributeValue,
    deleteBusinessObjectAttributeValues,
    mergeAttributeValues,
    importAttributeValues,
    updateBusinessObjectAttributeValue
} from '../../../actions/boCoreActions';
import * as toastr from "toastr";
import {AttributeValue} from "../models/AttributeValue";
import {BusinessObject} from "../models/BusinessObject";
import {DataTypesEnum} from "../enums/dataTypesEnum";
import BusinessObjects from "../../../views/bo-core/BusinessObjects";
import {numberComparator, stringComparator} from "../common/slickGridComparators";
import {EVENTS} from "../../../config/boCore";
import Utils from "../../../Utils";
import LoadingModal from "../modals/LoadinModal";

interface Props {
    currentAttribute: any;
    currentBusinessObject: any;
    currentAttributeValue: any;

    createBusinessObjectAttributeValue(args: any, dto: any): void;

    updateBusinessObjectAttributeValue(args: any, dto: any): void;

    deleteBusinessObjectAttributeValue(args: any): void;

    mergeAttributeValues(attributeId: number, dto: object, successCallback?: any, rejectCallback?: any);

    deleteBusinessObjectAttributeValues(attributeId: number, dto: object, successCallback?: any, rejectCallback?: any);
}

interface State {
    loading: boolean;
    $importTargetContent: any;
}

const lastEditableCol = 4, firstEditableCol = 1;
declare const Slick: any;

class BusinessObjectAttributeValueListGrid extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            $importTargetContent: Utils.$('<div></div>')
                .append($("<label>Please select .TSV file to import values:</label>"))
                .append($("<div style='padding-top: 5px' id='buttons-container'/>")
                    .append($("<input id='choose-files' style='float: left' type='file' accept='.tsv' />"))
                    .append($("<input id='submit-files' type='button' style='float: right; color: black' value='Submit'/>"))),
        }
    }

    UNSAFE_componentWillMount() {
        $(document.body)
            .unbind(EVENTS.boView.valueListGrid.open)
            .unbind(EVENTS.boView.valueListGrid.create)
            .unbind(EVENTS.boView.valueListGrid.update)
            .unbind(EVENTS.boView.valueListGrid.delete)
            .on(EVENTS.boView.valueListGrid.open, (event: any) => {
                this.buildGrid(this.props.currentAttribute, event.args.valueId);
                event.preventDefault();
            })
            .on(EVENTS.boView.valueListGrid.create, (event: any) => {
                const grid = $("#BusinessObjectAttributeValueListGrid").data("gridInstance");
                const dataView = grid.getData();

                const currentBusinessObject = this.props.currentBusinessObject;
                const currentAttribute = currentBusinessObject.getAttribute(event.args.attribute.id);
                const newAttributeValue = currentAttribute.getAttributeValue(event.args.name).clone();

                this.props.currentAttribute.attributeValues.set(newAttributeValue.id, newAttributeValue);

                dataView.beginUpdate();
                dataView.deleteItem(-1);
                dataView.insertItem(0, newAttributeValue.clone());
                dataView.endUpdate();

                if (event.args.withNewRow) {
                    addNewRow(dataView);
                    setTimeout(() => {
                        grid.setSelectedRows([0]);
                        grid.setActiveCell(0, 1);
                    });
                } else {
                    setTimeout(() => {
                        grid.setSelectedRows([0]);
                        BusinessObject.enableButton("value-list-new-btn");
                    });
                }
                BusinessObject.disableButton("value-list-save-btn");
                event.preventDefault();
            })
            .on(EVENTS.boView.valueListGrid.update, (event: any) => {
                const grid = $("#BusinessObjectAttributeValueListGrid").data("gridInstance");
                const attributeValue = event.args.attributeValue;
                const currentAttribute = this.props.currentAttribute;
                const currentAttributeValue = currentAttribute.getAttributeValue(attributeValue.id);
                currentAttributeValue.name = attributeValue.name;
                currentAttributeValue.description = attributeValue.description;
                currentAttributeValue.systemRequired = attributeValue.systemRequired;
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows(grid.getSelectedRows());
                });
            })
            .on(EVENTS.boView.valueListGrid.delete, (event: any) => {
                const {currentBusinessObject, currentAttribute} = this.props;
                const grid = $("#BusinessObjectAttributeValueListGrid").data("gridInstance");
                const dataView = grid.getData();
                currentBusinessObject.getAttribute(event.args.data.attributeId).deleteValueListItem(event.args.data.attributeValueId);
                currentAttribute.deleteValueListItem(event.args.data.attributeValueId);
                const row = dataView.getRowById(event.args.data.attributeValueId);
                dataView.beginUpdate();
                dataView.deleteItem(event.args.data.attributeValueId);
                dataView.endUpdate();
                grid.invalidateRow(row);
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows([row]);
                    grid.render();
                });
            })
    }

    onOpenImportDialog = (e) => {
        const importTargetContent = this.state.$importTargetContent.clone();
        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Value List Data Import"
                },
                text: importTargetContent,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            events: {
                show: () => {
                    $(e.target).css("background-color", "#676A6C");
                },
                hide: () => {
                    Utils.$(e.target).css("background-color", "#1AB394");
                    Utils.$(e.target).qtip('destroy');
                },
                render: () => {
                    Utils.$("#submit-files")
                        .unbind()
                        .on("click", () => {
                            const file = Utils.$("#choose-files").prop("files")[0];
                            if(file) {
                                importAttributeValues(this.props.currentAttribute.id, file)
                                    .then(response => {
                                        Utils.$('.qtip-dark').remove();
                                        const currentBusinessObject = this.props.currentBusinessObject;
                                        const attribute = currentBusinessObject.getAttribute(this.props.currentAttribute.id);
                                        let values = attribute.getAttributeValues(DataTypesEnum.MAP);
                                        response.data.forEach(item => {
                                            const attr = new AttributeValue(item.id, item.name, item.description, item.systemRequired);
                                            this.props.currentAttribute.attributeValues.set(attr.id, attr);
                                            values.set(attr.id, attr);
                                        });
                                        this.buildGrid(this.props.currentAttribute, undefined)
                                    })
                            }else{
                                toastr.warning("Please attach a file first.")
                            }
                        })
                }
            },
            position: {
                my: 'top left',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    };

    buildGrid = (attribute, valueId) => {
        let data;
        let grid, dataView, columnFilters = {};
        data = attribute.getAttributeValues(DataTypesEnum.ARRAY).map(item => item.clone());

        const columns = [
            {
                id: "name",
                name: "Name",
                field: "name",
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "Merge Into",
                name: "Merge Into",
                field: undefined,
                minWidth: 20,
                sortable: false,
                formatter: (row, cell, value, columnDef, dataContext) => {
                    return '<input type="radio" name="mergeInto" value="' + dataContext.id +'" />';
                }
            },
            {
                id: "description",
                name: "Description",
                field: "description",
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "systemRequired",
                name: "System Required",
                field: "systemRequired",
                width: 90,
                sortable: true,
                resizable: false,
                editor: SwitchEditor
            }
        ];

        function filter(item) {
            const keys = Object.keys(columnFilters);
            for (let i = 0; i < keys.length; i++) {
                if (keys[i] !== undefined && columnFilters[keys[i]] !== "") {
                    const c = grid.getColumns()[grid.getColumnIndex(keys[i])];
                    if (!item[c.field].toString().toLowerCase().includes(columnFilters[keys[i]].toString().toLowerCase())) {
                        return false;
                    }
                }
            }
            return true;
        }

        const getCurrentAttributeValue = () => {
            return this.props.currentAttributeValue;
        };
        const getCurrentBusinessObject = () => {
            return this.props.currentBusinessObject;
        };
        const getCurrentAttribute = () => {
            return this.props.currentAttribute
        };

        function removeFilters() {
            columnFilters = {};
            let header = grid.getHeaderRow();
            $(header).children('div').each(function (index, element) {
                if (index !== 0) {
                    $(element).children().val("");
                }

            });
        }

        function SwitchEditor(args) {
            let $input, defaultValue;
            this.init = function () {
                $input = Utils.$("<input id='toggle-one' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-size='mini'/>");
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.prop('checked', args.item[args.column.field]);

                $input.bootstrapToggle({
                    on: 'true',
                    off: 'false'
                });

                $input.change(function () {
                    const currentAttribute = getCurrentAttribute();
                    const currentAttributeValue = getCurrentAttributeValue();
                    const originalAttributeValue = currentAttribute.getAttributeValue(currentAttributeValue.id);
                    if (originalAttributeValue && originalAttributeValue.systemRequired && !$input[0].checked) {
                        Utils.$.confirm({
                            title: 'Confirm?',
                            keyboardEnabled: true,
                            escapeKey: 'cancel',
                            backgroundDismiss: false,
                            content: 'Unlocking this Attribute Value may cause problem with some functionalities. Are you sure you want to continue?',
                            type: 'red',
                            theme: 'dark',
                            typeAnimated: false,
                            buttons: {
                                ok: {
                                    text: "Yes!",
                                    btnClass: 'btn-danger',
                                    keys: ['enter'],
                                    action: () => {
                                        setRequired();
                                        saveAttributeValue(false);
                                    }
                                },
                                cancel: function () {
                                    $input.bootstrapToggle("toggle")
                                }
                            }
                        });
                    } else {
                        setRequired()
                    }

                    function setRequired() {
                        currentAttributeValue[args.column.field] = $input[0].checked;
                        const result = currentAttribute.checkAttributeValueBeforeSave(currentAttributeValue);
                        BusinessObjects.appendQtipsToNode(result.data, grid, $("#value-list-save-btn"));
                        if (!result.valid) {
                            BusinessObject.disableButton("value-list-save-btn");
                            return;
                        }
                        BusinessObject.enableButton("value-list-save-btn", "");
                    }
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                this.isValueChanged = function () {
                    return args.item.input !== $input.val()
                };
                this.loadValue = function (item) {
                    defaultValue = item[args.column.field];
                    $input.val(defaultValue);
                    $input.select();
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    item[args.column.field] = $input[0].checked;
                };
                this.validate = function () {
                    return {valid: true, msg: null}
                };
            };
            this.init();
        }

        function TextEditor(args) {
            let $input, defaultValue;

            this.init = function () {
                $input = Utils.$(`<input type=text class='editor-text rounded' />`);
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.keyup(function (e) {
                    const currentAttribute = getCurrentAttribute();
                    const currentAttributeValue = getCurrentAttributeValue();

                    if (currentAttributeValue) {
                        currentAttributeValue[args.column.field] = e.target.value;
                        const result = currentAttribute.checkAttributeValueBeforeSave(currentAttributeValue);
                        BusinessObjects.appendQtipsToNode(result.data, grid, $("#value-list-save-btn"));

                        if (result && !result.valid) {
                            BusinessObject.disableButton("value-list-save-btn");
                            BusinessObject.enableButton("value-list-new-btn");
                            BusinessObject.enableButton("value-list-merge-btn");
                            BusinessObject.enableButton("value-list-import-btn");
                            return;
                        }
                        BusinessObject.disableButton("value-list-new-btn");
                        BusinessObject.disableButton("value-list-merge-btn");
                        BusinessObject.disableButton("value-list-import-btn");
                        BusinessObject.enableButton("value-list-save-btn", "");
                    }
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                this.isValueChanged = function () {
                    return (!($input.val() === "" && defaultValue == null)) && ($input.val() !== defaultValue);
                };
                this.loadValue = function (item) {
                    defaultValue = item[args.column.field] || "";
                    $input.val(defaultValue);
                    $input[0].defaultValue = defaultValue;
                    $input.select();
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    const currentAttributeValue = getCurrentAttributeValue();
                    if (currentAttributeValue) {
                        item[args.column.field] = currentAttributeValue[args.column.field];
                    }
                };
                this.validate = function () {
                    const currentAttribute = getCurrentAttribute();
                    const currentAttributeValue = getCurrentAttributeValue();
                    switch (args.column.field) {
                        case "name": {
                            if ((currentAttribute && currentAttributeValue) &&
                                currentAttribute.hasAttributeValueByNameExceptId(currentAttributeValue.name, currentAttributeValue.id)) {
                                return {
                                    valid: false,
                                    msg: `Attribute value with name: ${currentAttributeValue[args.column.field]} already exists.`
                                }
                            }
                        }
                            break;
                    }
                    return {valid: true, msg: null}
                }
            };
            this.init();
        }

        const options = {
            enableCellNavigation: true,
            enableColumnReorder: false,
            forceFitColumns: true,
            multiColumnSort: false,
            editable: true,
            showHeaderRow: true,
            headerRowHeight: 30,
            autoEdit: true,
            explicitInitialization: true
        };

        function attachAutoResizeDataGrid(grid, gridId) {
            const gridDomElm = $('#' + gridId);
            if (!gridDomElm || typeof gridDomElm.offset() === "undefined") {
                return null;
            }
            if ($(document.body).hasClass("mini-navbar")) {
                resizeToFitBrowserWindow(grid, gridId, true);
            } else {
                resizeToFitBrowserWindow(grid, gridId, false);
            }
            $("#hide-nav-btn").on("click", function () {
                if (!$(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });
            $(window).on("resize", function () {
                if ($(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });
        }

        function calculateNewDimensions(printMode, minNavBarEnabled) {
            const $accordeon = $("#accordeon");
            if (minNavBarEnabled) {
                return {
                    height: $accordeon.height() - 54,
                    width: "100%"
                }
            }

            return {
                height: $accordeon.height() - 54,
                width: "100%"
            }
        }

        function resizeToFitBrowserWindow(grid, gridId, minNavBarEnabled) {
            const newSizes = calculateNewDimensions(null, minNavBarEnabled);

            $('#' + gridId)
                .height(newSizes.height)
                .width(newSizes.width);

            if (new RegExp('MSIE [6-8]').exec(navigator.userAgent) === null && grid) {
                grid.resizeCanvas();
            }
        }

        const saveAttributeValue = (withNewRow) => {
            const currentBusinessObject = getCurrentBusinessObject();
            const currentAttribute = getCurrentAttribute();
            const currentAttributeValue = getCurrentAttributeValue();
            const result = currentAttribute.checkAttributeValueBeforeSave(currentAttributeValue);
            if (result.valid) {
                if (grid.getEditorLock().isActive()) {
                    grid.getEditorLock().commitCurrentEdit();
                }
                const dto = {
                    name: currentAttributeValue.name,
                    description: currentAttributeValue.description,
                    systemRequired: currentAttributeValue.systemRequired,
                };
                if (currentAttributeValue.id === -1) {
                    this.props.createBusinessObjectAttributeValue({
                            event: EVENTS.boView.valueListGrid.create,
                            attribute: currentAttribute,
                            boClass: currentBusinessObject,
                            withNewRow
                        },
                        dto
                    );
                } else {
                    this.props.updateBusinessObjectAttributeValue({
                        event: EVENTS.boView.valueListGrid.update,
                        attribute: currentAttribute,
                        attributeValue: currentAttributeValue,
                        boClass: currentBusinessObject
                    }, dto);
                }
                BusinessObject.enableButton("value-list-new-btn");
                BusinessObject.enableButton("value-list-merge-btn");
                BusinessObject.enableButton("value-list-import-btn");
            } else {
                BusinessObject.disableButton("value-list-save-btn");
                BusinessObjects.appendQtipsToNode(result.data, grid, $("#value-list-save-btn"));
            }
        };

        $(() => {
            const $businessObjectAttributeValueListGrid = $("#BusinessObjectAttributeValueListGrid");
            dataView = new Slick.Data.DataView();
            dataView.beginUpdate();
            dataView.setItems(data);
            dataView.setFilter(filter);
            dataView.endUpdate();
            let checkboxSelector = new Slick.CheckboxSelectColumn({
                cssClass: "slick-cell-checkboxsel",
                columnId: "value-list-grid-checkbox"
            });
            columns.unshift(checkboxSelector.getColumnDefinition());
            if ($businessObjectAttributeValueListGrid[0]) {
                grid = new Slick.Grid("#BusinessObjectAttributeValueListGrid", dataView, columns, options);
                $businessObjectAttributeValueListGrid.data("gridInstance", grid);
                grid.registerPlugin(checkboxSelector);

                grid.onSort.subscribe(function (e, args) {
                    const currentAttributeValue = getCurrentAttributeValue();
                    const currentAttribute = getCurrentAttribute();
                    if (currentAttributeValue) {
                        if (currentAttribute.getAttributeValue(currentAttributeValue.id)) {
                            const attributeValue = currentAttribute.getAttributeValue(currentAttributeValue.id);
                            if (!attributeValue.equal(currentAttributeValue)) {
                                confirm(attributeValue);
                            } else {
                                sort()
                            }
                        } else {
                            confirm();
                        }
                    } else {
                        sort();
                    }

                    function confirm(attributeValue?: any) {
                        Utils.$.confirm({
                            title: 'Confirm?',
                            keyboardEnabled: true,
                            escapeKey: 'cancel',
                            backgroundDismiss: false,
                            content: 'There are unsaved changes. Are you sure you want to continue?',
                            type: 'red',
                            theme: 'dark',
                            typeAnimated: false,
                            buttons: {
                                ok: {
                                    text: "Yes!",
                                    btnClass: 'btn-danger',
                                    keys: ['enter'],
                                    action: () => {
                                        if (grid.getEditorLock().isActive()) {
                                            grid.getEditorLock().cancelCurrentEdit();
                                        }
                                        if (attributeValue) {
                                            currentAttributeValue.name = attributeValue.name;
                                            currentAttributeValue.description = attributeValue.description;
                                            currentAttributeValue.systemRequired = attributeValue.systemRequired;
                                        } else {
                                            dataView.beginUpdate();
                                            dataView.deleteItem(-1);
                                            Utils.eventDispatcher(EVENTS.boView.setAttributeValue, {
                                                attributeValue: null
                                            })
                                            dataView.endUpdate();
                                            grid.setSelectedRows([0]);
                                            BusinessObject.enableButton("value-list-new-btn");
                                            BusinessObject.enableButton("value-list-merge-btn");
                                            BusinessObject.enableButton("value-list-import-btn");
                                            BusinessObject.enableButton("value-list-delete-btn");
                                        }
                                        sort();
                                    }
                                },
                                cancel: function () {

                                }
                            }
                        });
                    }

                    function sort() {
                        const sortCol = args.sortCol;
                        dataView.sort(function (dataRow1, dataRow2) {
                            const field = sortCol.field;
                            const sign = args.sortAsc ? 1 : -1;

                            const value1 = dataRow1[field];
                            const value2 = dataRow2[field];
                            switch (field) {
                                case "minLength":
                                case "maxLength":
                                case "maxDigitsLeftOfDecimal":
                                case "minDigitsRightOfDecimal":
                                case "sequence":
                                    return numberComparator(value1, value2, sign);
                                default:
                                    return stringComparator(value1, value2, sign);
                            }
                        });
                        grid.invalidate();
                        grid.updateRowCount();
                        grid.resizeCanvas();
                        grid.render();
                    }
                });

                dataView.onRowCountChanged.subscribe(function () {
                    grid.updateRowCount();
                    grid.render();
                });

                dataView.onRowsChanged.subscribe(function (e, args) {
                    grid.invalidateRows(args.rows);
                    grid.render();
                });

                Utils.$(grid.getHeaderRow()).delegate(":input", "change keyup search", function () {
                    let columnId = $(this).data("columnId");
                    if (columnId != null) {
                        columnFilters[columnId] = Utils.$.trim($(this).val());
                        dataView.refresh();
                    }
                });

                grid.onHeaderRowCellRendered.subscribe(function (e, args) {
                    $(args.node).empty();
                    if (args.column.id !== "value-list-grid-checkbox") {
                        $(`<input class=rounded type='search' placeholder="🔍">`)
                            .data("columnId", args.column.id)
                            .val(columnFilters[args.column.id])
                            .appendTo(args.node);
                    }
                });

                grid.onSelectedRowsChanged.subscribe((e) => {
                    const row = grid.getSelectedRows()[0];
                    const item = dataView.getItem(row);
                    if (item) {
                        Utils.eventDispatcher(EVENTS.boView.setAttributeValue, {
                            attributeValue: item.clone()
                        });
                    } else {
                        Utils.eventDispatcher(EVENTS.boView.setAttributeValue, {
                            attributeValue: null
                        });
                    }
                    BusinessObject.disableButton("value-list-save-btn");
                    Utils.$(".qtip").remove();
                    Utils.$('[data-hasqtip]').qtip('destroy', true);
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                });

                grid.onBeforeRowChange = function (e, args) {
                    const currentAttributeValue = getCurrentAttributeValue();
                    const currentAttribute = getCurrentAttribute();
                    if (currentAttributeValue) {
                        if (currentAttribute.hasAttributeValue(currentAttributeValue.id)) {
                            const attributeValue = currentAttribute.getAttributeValue(currentAttributeValue.id);
                            if (!attributeValue.equal(currentAttributeValue)) {
                                Utils.$.confirm({
                                    title: 'Confirm?',
                                    keyboardEnabled: true,
                                    escapeKey: 'cancel',
                                    backgroundDismiss: false,
                                    content: 'There are unsaved changes. Are you sure you want to continue?',
                                    type: 'red',
                                    theme: 'dark',
                                    typeAnimated: false,
                                    buttons: {
                                        ok: {
                                            text: "Yes!",
                                            btnClass: 'btn-danger',
                                            keys: ['enter'],
                                            action: () => {
                                                if (grid.getEditorLock().isActive()) {
                                                    grid.getEditorLock().cancelCurrentEdit();
                                                }
                                                currentAttributeValue.name = attributeValue.name;
                                                currentAttributeValue.description = attributeValue.description;
                                                currentAttributeValue.systemRequired = attributeValue.systemRequired;

                                                dataView.beginUpdate();
                                                dataView.updateItem(currentAttributeValue.id, currentAttributeValue.clone());
                                                dataView.endUpdate();

                                                grid.setSelectedRows([args.row]);
                                                grid.setActiveCell(args.row, args.cell);
                                            }
                                        },
                                        cancel: function () {

                                        }
                                    }
                                });
                                e.preventDefault();
                                e.stopImmediatePropagation();
                            }
                        } else {
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: 'There are unsaved changes. Are you sure you want to continue?',
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-danger',
                                        keys: ['enter'],
                                        action: () => {
                                            if (grid.getEditorLock().isActive()) {
                                                grid.getEditorLock().cancelCurrentEdit();
                                            }
                                            dataView.beginUpdate();
                                            dataView.deleteItem(-1);
                                            dataView.endUpdate();
                                            grid.setSelectedRows([args.row - 1]);
                                            grid.setActiveCell(args.row - 1, args.cell);
                                            BusinessObject.enableButton("value-list-new-btn");
                                        }
                                    },
                                    cancel: function () {

                                    }
                                }
                            });
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        }
                    }
                };

                grid.onBeforeEditCell.subscribe(function (e, args) {
                    const currentAttribute = getCurrentAttribute();
                    const currentAttributeValue = getCurrentAttributeValue();
                    const prevSelected = grid.getSelectedRows()[0];
                    const activeCell = grid.getActiveCell();
                    const activeCellObj = grid.getDataItem(activeCell.row);

                    let originalAttributeValue;
                    if (currentAttributeValue) {
                        originalAttributeValue = currentAttribute.getAttributeValue(currentAttributeValue.id);
                        if (activeCellObj.systemRequired && args.column.field !== "systemRequired") {
                            toastr.warning("The Attribute Value you are trying to edit is required for the system. Please set System Required to false and save it to continue editing.");
                            grid.setActiveCell(prevSelected, 1);
                            BusinessObject.enableButton("value-list-save-btn", "");
                            return false;
                        }

                        if (originalAttributeValue && !originalAttributeValue.equal(currentAttributeValue) && args.row !== prevSelected) {
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: 'There are unsaved changes. Do you want to save them?',
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-success',
                                        keys: ['enter'],
                                        action: () => {
                                            grid.setActiveCell(prevSelected, 1);
                                            saveAttributeValue(false);
                                            BusinessObject.enableButton("value-list-new-btn");
                                            BusinessObject.enableButton("value-list-merge-btn");
                                            BusinessObject.enableButton("value-list-import-btn");
                                        }
                                    },
                                    discard: {
                                        text: "Discard Changes",
                                        btnClass: 'btn-danger',
                                        action: () => {
                                            if (grid.getEditorLock().isActive()) {
                                                grid.getEditorLock().cancelCurrentEdit();
                                            }
                                            currentAttributeValue.name = originalAttributeValue.name;
                                            currentAttributeValue.description = originalAttributeValue.description;
                                            currentAttributeValue.systemRequired = originalAttributeValue.systemRequired;

                                            dataView.beginUpdate();
                                            dataView.updateItem(currentAttributeValue.id, currentAttributeValue.clone());
                                            dataView.endUpdate();

                                            grid.setSelectedRows([args.row]);
                                            BusinessObject.enableButton("value-list-new-btn");
                                            BusinessObject.enableButton("value-list-merge-btn");
                                            BusinessObject.enableButton("value-list-import-btn");
                                        }
                                    },
                                    cancel: function () {
                                        grid.setActiveCell(prevSelected, 1);
                                        BusinessObject.enableButton("value-list-save-btn", "");
                                    }
                                }
                            });
                            e.stopImmediatePropagation();
                            return false;
                        } else if (currentAttributeValue.id === -1 && args.row !== prevSelected) {
                            // if the value is new
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: 'There are unsaved changes. Do you want to save them?',
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-success',
                                        keys: ['enter'],
                                        action: () => {
                                            saveAttributeValue(false);
                                            BusinessObject.enableButton("value-list-merge-btn");
                                            BusinessObject.enableButton("value-list-import-btn");
                                            BusinessObject.enableButton("value-list-new-btn");
                                        }
                                    },
                                    discard: {
                                        text: "Discard Changes",
                                        btnClass: 'btn-danger',
                                        action: () => {
                                            if (grid.getEditorLock().isActive()) {
                                                grid.getEditorLock().cancelCurrentEdit();
                                            }
                                            dataView.beginUpdate();
                                            dataView.deleteItem(-1);
                                            dataView.endUpdate();

                                            BusinessObject.enableButton("value-list-new-btn");
                                            BusinessObject.enableButton("value-list-merge-btn");
                                            BusinessObject.enableButton("value-list-import-btn");
                                            grid.setSelectedRows([0]);
                                        }
                                    },
                                    cancel: function () {
                                        grid.setActiveCell(prevSelected, 1);
                                        BusinessObject.enableButton("value-list-save-btn", "");
                                    }
                                }
                            });
                            e.stopImmediatePropagation();
                            return false;
                        } else {
                            grid.setSelectedRows([args.row]);
                        }
                    }
                });

                grid.onKeyDown.subscribe(function (event) {
                    if (event.keyCode === 9 && event.shiftKey === false) {
                        const activeCell = grid.getActiveCell();
                        if (activeCell && activeCell.cell === lastEditableCol) {
                            if (!$("#value-list-save-btn").prop("disabled")) {
                                saveAttributeValue(true);
                            } else {
                                grid.gotoCell(grid.getActiveCell().row, firstEditableCol, true);
                            }
                            event.stopImmediatePropagation();
                        } else if (activeCell && activeCell.cell === 0) {
                            const activeCellObj = grid.getDataItem(activeCell.row);
                            if (!activeCellObj.systemRequired) {
                                grid.setActiveCell(activeCell.row, 1)
                            }
                            event.preventDefault();
                            event.stopImmediatePropagation();
                        } else if (!activeCell){
                            event.preventDefault();
                            event.stopImmediatePropagation();
                        }
                    }
                    if (event.keyCode === 9 && event.shiftKey === true) {
                        if (grid.getActiveCell().cell === firstEditableCol) {
                            grid.gotoCell(grid.getActiveCell().row, lastEditableCol, true);
                            event.stopImmediatePropagation();
                        }
                    }
                    if (event.keyCode === 13) {
                        grid.getEditController().commitCurrentEdit();
                        event.stopImmediatePropagation();
                    }
                });

                grid.onClick.subscribe(function (e, args) {
                    if (grid.getEditorLock().isActive()) {
                        grid.getEditorLock().commitCurrentEdit();
                    }
                });

                grid.onValidationError.subscribe(function (e, args) {
                    toastr.warning(args.validationResults.msg);
                });

                $("#value-list-new-btn")
                    .unbind()
                    .click(() => {
                        removeFilters();
                        const dataView = grid.getData();
                        const attributeValue = dataView.getItem(0);
                        if (attributeValue && attributeValue.id === -1) {
                            toastr.warning("There is already a blank line.");
                            BusinessObject.disableButton("value-list-new-btn");
                            return;
                        }
                        addNewRow(dataView);
                        grid.setSelectedRows([0]);
                        grid.setActiveCell(0, 1);
                    });
                $("#value-list-save-btn")
                    .unbind()
                    .click(() => {
                        if (!$("#value-list-save-btn").prop("disabled")) {
                            saveAttributeValue(false);
                        }
                    });

                $("#value-list-delete-btn")
                    .unbind()
                    .click(() => {
                        const attributes = [];
                        let selectedRowsIds = grid.getSelectedRows().map(row => {
                            const item = dataView.getItem(row);
                            attributes.push(item);
                            return item.id;
                        });
                        if (selectedRowsIds.length) {
                            const currentAttribute = getCurrentAttribute();
                            const currentAttributeValue = getCurrentAttributeValue();
                            if (currentAttribute.hasAttributeValue(currentAttributeValue.id)) {
                                /*const isErasable = currentAttributeValue.isErasable();
                                if (!isErasable.erasable) {
                                    toastr.warning(isErasable.msg);
                                    return;
                                }*/
                                Utils.$.confirm({
                                    title: 'Confirm?',
                                    keyboardEnabled: true,
                                    escapeKey: 'cancel',
                                    backgroundDismiss: false,
                                    content: `You are about to delete ${selectedRowsIds.length} attribute` +
                                        ` ${selectedRowsIds.length > 1 ? 'values' : 'value'}, this procedure is irreversible.`,
                                    type: 'red',
                                    theme: 'dark',
                                    typeAnimated: false,
                                    buttons: {
                                        ok: {
                                            text: "Yes!",
                                            btnClass: 'btn-danger',
                                            keys: ['enter'],
                                            action: () => {
                                                const dto = {
                                                    ids: selectedRowsIds,
                                                };
                                                this.setState({loading: true}, () => {
                                                    this.props.deleteBusinessObjectAttributeValues(
                                                        this.props.currentAttribute.id, dto,
                                                        () => {
                                                            this.setState({loading: false}, () => {
                                                                toastr.success("Attribute values are deleted successfully.");
                                                                BusinessObject.enableButton("value-list-new-btn");
                                                                BusinessObject.enableButton("value-list-merge-btn");
                                                                BusinessObject.enableButton("value-list-import-btn");
                                                                selectedRowsIds.forEach(rowId => {
                                                                    const row = dataView.getRowById(rowId);
                                                                    dataView.beginUpdate();
                                                                    dataView.deleteItem(rowId);
                                                                    dataView.endUpdate();
                                                                    grid.invalidateRow(row);
                                                                    grid.render();
                                                                });
                                                                grid.setSelectedRows([]);
                                                                const currentBusinessObject = this.props.currentBusinessObject;
                                                                const attribute = currentBusinessObject.getAttribute(this.props.currentAttribute.id);
                                                                const currentAttribute = getCurrentAttribute();
                                                                attributes.forEach(attr => {
                                                                    // this updates the currentBusinessObject attributes
                                                                    attribute.deleteValueListItem(attr.id);
                                                                    // this updates the attribute only
                                                                    currentAttribute.deleteValueListItem(attr.id);
                                                                });
                                                                grid.setSelectedRows([0]);
                                                            })
                                                        },
                                                        (e: any) => {
                                                            try {
                                                                toastr.error(e.response.data.message);
                                                            } catch (error) {
                                                                console.error(error);
                                                            } finally {
                                                                this.setState({loading: false});
                                                            }
                                                        })
                                                });
                                            }
                                        },
                                        cancel: function () {
                                        }
                                    }
                                });
                            } else {
                                const row = dataView.getRowById(currentAttributeValue.id);
                                dataView.beginUpdate();
                                dataView.deleteItem(currentAttributeValue.id);
                                dataView.endUpdate();
                                grid.invalidateRow(row);
                                grid.setSelectedRows([row]);
                                grid.render();
                                grid.setSelectedRows([0]);
                                BusinessObject.enableButton("value-list-new-btn");
                                BusinessObject.enableButton("value-list-merge-btn");
                                BusinessObject.enableButton("value-list-import-btn");
                            }
                        }
                    });
                $("#value-list-merge-btn")
                    .unbind()
                    .click(() => {
                        let mergeIntoId = null;
                        if (document.querySelector('input[name="mergeInto"]:checked')) {
                            // @ts-ignore
                            mergeIntoId = parseInt(document.querySelector('input[name="mergeInto"]:checked').value);
                        }
                        const attributesForMerge = [];
                        let selectedRowsIds = grid.getSelectedRows().map(row => {
                            const item = dataView.getItem(row);
                            attributesForMerge.push(item);
                            return item.id;
                        });
                        if (mergeIntoId && selectedRowsIds.length) {
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: `You are about to merge ${selectedRowsIds.length}` +
                                    ` ${selectedRowsIds.length > 1 ? 'values' : 'value'}, this procedure is irreversible.`,
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-danger',
                                        keys: ['enter'],
                                        action: () => {
                                            const dto = {
                                                mergeToValueId: mergeIntoId,
                                                mergedValuesIds: selectedRowsIds,
                                            };
                                            this.setState({loading: true}, () => {
                                                this.props.mergeAttributeValues(this.props.currentAttribute.id, dto,
                                                    () => {
                                                        this.setState({loading: false}, () => {
                                                            toastr.success("Attribute values are merged successfully.");
                                                            selectedRowsIds.forEach(rowId => {
                                                                if (rowId !== mergeIntoId) {
                                                                    const row = dataView.getRowById(rowId);
                                                                    dataView.beginUpdate();
                                                                    dataView.deleteItem(rowId);
                                                                    dataView.endUpdate();
                                                                    grid.invalidateRow(row);
                                                                    grid.render();
                                                                }
                                                            });
                                                            grid.setSelectedRows([]);
                                                            const currentBusinessObject = this.props.currentBusinessObject;
                                                            const attribute = currentBusinessObject.getAttribute(this.props.currentAttribute.id);
                                                            let values = attribute.getAttributeValues(DataTypesEnum.MAP);
                                                            let currAttrValues = this.props.currentAttribute.getAttributeValues(DataTypesEnum.MAP);
                                                            attributesForMerge.forEach(attr => {
                                                                if (attr.id !== mergeIntoId) {
                                                                    values.delete(attr.id);
                                                                    currAttrValues.delete(attr.id);
                                                                }
                                                            });
                                                        })
                                                    },
                                                    (e: any) => {
                                                        try {
                                                            toastr.error(e.response.data.message);
                                                        } catch (error) {
                                                            console.error(error);
                                                        } finally {
                                                            this.setState({loading: false});
                                                        }
                                                    })
                                            });
                                        }
                                    },
                                    cancel: () => {
                                    }
                                },
                            });
                        }
                    });

                new Slick.Controls.ColumnPicker(columns, grid, options);
                grid.setSelectionModel(new Slick.RowSelectionModel({selectActiveRow: false}));
                dataView.syncGridSelection(grid, true, false);
                grid.init();
                if (dataView.getLength() === 0) {
                    addNewRow(dataView);
                }
                grid.setSelectedRows([dataView.getRowById(valueId) | 0]);
                attachAutoResizeDataGrid(grid, "BusinessObjectAttributeValueListGrid");
                BusinessObject.enableButton("value-list-new-btn");
            }
        });
    };

    render() {
        const {currentBusinessObject, currentAttribute} = this.props;
        if (!currentBusinessObject || !currentAttribute) return null;
        return (
            <div>
                <div className="bo-core-header background-gradient" style={{marginBottom: 5, paddingTop: 5}}>
                    <label style={
                        {
                            marginLeft: 2,
                            float: "left",
                            color: "#FFFFFF",
                            paddingTop: 7,
                            fontSize: 18,
                            width: "calc(100% - 330px)",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        }
                    }
                           title={`Type: ${currentBusinessObject.name} Attribute: ${currentAttribute.name}`}
                    >
                        {`Type: ${currentBusinessObject.name} Attribute: ${currentAttribute.name}`}
                    </label>
                    <div style={{width: 325, float: "right"}}>
                        <button style={{marginRight: 2}} id="value-list-new-btn" className="btn btn-success">New
                        </button>
                        <button style={{marginRight: 2}} disabled id="value-list-save-btn" className="btn btn-primary">Save
                        </button>
                        <button style={{marginRight: 2}} id="value-list-delete-btn" className="btn btn-danger">Delete
                        </button>
                        <button id="value-list-merge-btn" className="btn btn-warning">Merge
                        </button>
                        <button
                            onClick={this.onOpenImportDialog}
                            className={"btn btn-success"}
                            id={'value-list-import-btn'}
                            style={{marginLeft: 2}}>
                            <i className="fas fa-upload"> Import</i>
                        </button>
                    </div>
                </div>
                <div className="custom-header" style={{border: "0px", backgroundColor: "#FFFFFF"}}
                     id="BusinessObjectAttributeValueListGrid"/>
                <LoadingModal open={this.state.loading}/>
            </div>
        )
    }
}

function addNewRow(dataView) {
    dataView.beginUpdate();
    dataView.insertItem(0, new AttributeValue(-1, "", "n/a", false));
    dataView.endUpdate();
    BusinessObject.disableButton("value-list-new-btn");
    BusinessObject.disableButton("value-list-merge-btn");
    BusinessObject.disableButton("value-list-import-btn");
}

const mapStateToProps = (state, ownProps) => {
    return {
        currentAttribute: ownProps.currentAttribute,
        currentBusinessObject: ownProps.currentBusinessObject,
        currentAttributeValue: ownProps.currentAttributeValue
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        createBusinessObjectAttributeValue: (args, dto) => {
            dispatch(createBusinessObjectAttributeValue(args, dto));
        },
        updateBusinessObjectAttributeValue: (args, dto) => {
            dispatch(updateBusinessObjectAttributeValue(args, dto));
        },
        deleteBusinessObjectAttributeValue: (args) => {
            dispatch(deleteBusinessObjectAttributeValue(args));
        },
        mergeAttributeValues: (attributeId: number, dto: object, successCallback?: any, rejectCallBack?: any) => {
            dispatch(mergeAttributeValues(attributeId, dto, successCallback, rejectCallBack));
        },
        deleteBusinessObjectAttributeValues: (attributeId: number, dto: object, successCallback?: any, rejectCallBack?: any) => {
            dispatch(deleteBusinessObjectAttributeValues(attributeId, dto, successCallback, rejectCallBack));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(BusinessObjectAttributeValueListGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/BusinessObjectAttributeValueListGrid.tsx